<template>
  <div class="user-actions">
    <mode-switcher/>
    <pause-controller/>
  </div>
</template>

<script>
import ModeSwitcher from './UserAction/ModeSwitcher';
import PauseController from './UserAction/PauseController';

export default {
  name: 'UserAction',
  components: {
    'mode-switcher': ModeSwitcher,
    'pause-controller': PauseController,
  },
};
</script>

<style lang="scss">
.user-actions {
  box-sizing: border-box;
  width: 100%;
  background: rgba(#000, 0.3);
  box-shadow: 0 -2px 10px 0 rgba(#000, 0.1);

  .user-action-button {
    font-size: 1.5rem;
    display: inline-block;
    background: rgba(#000, 0.3);
    padding: 1.2rem;
    border-radius: 1.5rem;
    transition: transform 0.5s, background-color 0.5s;
    color: rgba(#fff, 1);
    cursor: pointer;
    outline: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    &:hover {
      background: rgba(#000, 0.8);
      transform: scale(1.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/UserAction.vue